exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-trash[data-v-1512fcec]{background:#f71717!important;color:#e7e5e5!important;-webkit-transition:all .3s ease;transition:all .3s ease}.custom-trash[data-v-1512fcec]:hover{background:rgba(247,23,23,.788)!important;color:#e7e5e5!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1512fcec","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./modules/Hotel/Resources/assets/js/views/rooms/Rent.vue
// module id = hrQg
// module chunks = 0